import { MailOutlined, PlusOutlined, MoneyCollectOutlined, DeleteOutlined, ArrowLeftOutlined, ArrowRightOutlined, UpOutlined, DownOutlined, ShareAltOutlined } from "@ant-design/icons"
import { Button, Popover, Modal, Flex, Input, Divider, Select } from "antd"
import { useDispatch, useSelector } from "react-redux"
import { setAddNodeInBetween, setNodeToBeDeleted, setSelectedStep, setSidebarOpen, setSidebarData, setSidebarType, setWorkflow } from "../../../redux/slices/connectorSlice";
import { Handle, Position } from "@xyflow/react";
import { useEffect, useState } from "react";
import { checkIfConnectorIsFromNoCondition } from "../../../utils/workflowHelper";
import { useParams } from "react-router-dom";
import { useTenantNavigation } from "../../../hooks/useTenantNavigation.js";
import SvgIcons from "../../layout/assets/SvgIcons";
import { ChevronDown, ChevronRight } from "lucide-react";
import UserRoleDropdown from "../../UserRoleDropdown";
import { useTranslation } from "react-i18next";
import { FORM_LANGUAGE_OPTIONS } from "../../../utils/formTranslations";
import { resolveNodeTranslation, setNodeLeafForLanguage, DEFAULT_LANGUAGE } from "../../../utils/workflowTranslations";
// import { defaultMenuItems } from "../../../utils/createEdgeNode";

const Connector = ({ data, id, position, draggable, selectable, type }) => {

    // removed unused menuItems
    // removed unused flow menu state
    const { spaceId } = useParams();
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useTenantNavigation();
    const [showMenu, setShowMenu] = useState(false)
     const [endStepName, setEndStepName] = useState(data?.name || "End")
    const [endExpanded, setEndExpanded] = useState(false)
    // Language the end-node label is authoring; defaults to (and follows) the app
    // language, overridable via the in-panel dropdown. Default language edits the
    // canonical `name`; others edit data.translations[lng] (status id preserved).
    const [editLang, setEditLang] = useState(i18n.language || DEFAULT_LANGUAGE)
    const { workflow } = useSelector(state => state.connector)

     useEffect(() => {
        setEditLang(i18n.language || DEFAULT_LANGUAGE)
    }, [i18n.language])

    // End-node label resolved for the language being edited (falls back to canonical).
    const endDisplayName = resolveNodeTranslation(data, editLang)?.name || "End"

     useEffect(() => {
        setEndStepName(endDisplayName)
    }, [endDisplayName])

    useEffect(() => {
        if (type === "circle") {
            checkIfConnectorIsFromNoCondition(id, workflow.nodes, workflow.edges)
        }
    }, [data, id, type, workflow.edges, workflow.nodes])

    // useEffect(() => {
    //     if(connectorMenu) {
    //         let updatedMenu = [...defaultMenuItems]
    //         switch(connectorMenu) {
    //             case "notification":

    //         }
    //     }
    // },[workflow])

    // removed unused handleTypeClick

    // removed unused handleNodeClick

    // removed unused mergeContent

    // removed unused content variable

    // A plain "+" connector is a parallel-branch sibling when its source node forks
    // into more than one outgoing edge. Such connectors can be deleted to drop the branch.
    const incomingEdge = (workflow?.edges || []).find(e => e.target === id)
    const isBranchConnector = incomingEdge
        ? (workflow?.edges || []).filter(e => e.source === incomingEdge.source).length > 1
        : false

    const handleConnectorClick = () => {
        if (data.type === 'httpRequest') {
            // Open the details panel (same pattern as Notification)
            dispatch(setSelectedStep({ data: { ...data, type: 'httpRequest' }, id }));
        } else if (data.type === 'duplicateCheck' || data.type === 'sharePublicForm') {
            dispatch(setSelectedStep({ data: { ...data }, id }));
        } else if (data.type === 'outlookCalendar') {
            dispatch(setSelectedStep({ data: { ...data, type: 'outlookCalendar' }, id }));
        } else if (data.type === 'googlePlaces') {
            dispatch(setSelectedStep({ data: { ...data, type: 'googlePlaces' }, id }));
        } else if (data.type === 'join') {
            dispatch(setSelectedStep({ data: { ...data, type: 'join' }, id }));
        } else {
            dispatch(setSelectedStep({ ...data, id: id }))
        }
    }

    const navigateToEstimation = () => {
        navigate("/app/space/" + spaceId + "/estimation-engine")
    }

    const handleRemoveNode = (targetId = id) => {
        // e.preventDefault();
        // e.stopPropagation();
        // data.onDelete(id)
        dispatch(setNodeToBeDeleted(targetId))
        dispatch(setSelectedStep({}))
    }

    const confirmNodeDelete = (e, targetId = id) => {
        e.preventDefault();
        e.stopPropagation();
        setShowMenu(false)
        Modal.confirm({
            title: t('Confirm'),
            content: t('Are you sure to delete the node?'),
            okText: t('Yes'),
            cancelText: t('No'),
            onOk: (event) => {
                handleRemoveNode(targetId)
                Modal.destroyAll()
            },
            footer: (_, { OkBtn, CancelBtn }) => (
                <>
                    <CancelBtn />
                    <OkBtn />
                </>
            ),
        });
    }

    const handleAddPhase = (e, side) => {
        e.preventDefault();
        e.stopPropagation();
        setShowMenu(false)

        dispatch(setAddNodeInBetween({ ...data, id: id, side: side }))
    }

    const menuContent = (targetId = id) => (
        <Flex vertical gap={8} style={{ width: "150px", padding: "8px" }}>
            {/* {data.type !== "end" && <Flex gap={8} style={{ width: "150px" }} className='cursor-pointer' onClick={(e) => handleAddPhase(e, "right")}><ArrowRightOutlined /><span>Add step to right</span></Flex>}
            <Flex gap={8} style={{ width: "130px" }} className='cursor-pointer' onClick={(e) => handleAddPhase(e, "left")}><ArrowLeftOutlined /><span>Add step to left</span></Flex> */}
            <Flex gap={8} style={{ width: "130px" }} className='cursor-pointer' onClick={(e) => confirmNodeDelete(e, targetId)}><DeleteOutlined style={{ color: "red" }} /><span>{t('Delete')}</span></Flex>
        </Flex>
    );

    const handleContextMenu = (event) => {
        event.preventDefault(); // Prevent the default context menu from appearing
    };

    const handleStepNameChange = (val) => {
        setEndStepName(val)
        let updatedWorkflow = { ...workflow }
        let updatedNodes = updatedWorkflow.nodes.map(node => {
            if (node.id === id) {
                return { ...node, data: setNodeLeafForLanguage(node.data, editLang, "name", val) }
            } else {
                return { ...node }
            }
        })
        updatedWorkflow.nodes = updatedNodes
        dispatch(setWorkflow({ ...updatedWorkflow }))
    }

    const handleNotifySelect = (values) => {
        const { nodes, edges } = workflow;
        const updatedNodes = nodes.map(node => {
            if (node.id === id) {
                return {
                    ...node,
                    data: {
                        ...node.data,
                        notifyTo: {
                            user: values.user,
                            role: values.role,
                            group: values.group,
                            userPicker: values.userPicker
                        }
                    }
                }
            }
            return { ...node }
        })
        dispatch(setWorkflow({ nodes: updatedNodes, edges }))
    }

    return (
        <>
            {
                data.type === "condition" ?
                    <>
                        <Handle type="target" position={Position.Left} style={{ top: "24px" }} />
                        <Handle type="source" position={Position.Bottom} style={{ bottom: "0" }} id="conditionb" />
                        <Handle type="source" position={Position.Right} style={{ top: "24px" }} id="conditiona" />

                        <div className="condition-node" onClick={handleConnectorClick}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                <rect width="28" height="28" fill="#E8E8FA" />
                                <path d="M8.77344 22.7451H18.1968" stroke="#141BCB" strokeWidth="1.29355" strokeDasharray="1.79 1.79" />
                                <path d="M17.9473 5.38184L12.9967 5.38184C11.4081 5.38184 10.0084 6.42595 9.55573 7.94868L5.38281 21.9849" stroke="#141BCB" stroke-width="1.29355" />
                                <rect width="8.97462" height="7.17969" rx="2.69238" transform="matrix(1 0 0 -1 0 26.4561)" fill="#141BCB" />
                                <rect x="26.9238" y="9.41992" width="8.97462" height="7.17969" rx="2.69238" transform="rotate(-180 26.9238 9.41992)" fill="#141BCB" />
                                <rect x="26.9238" y="26.4561" width="8.97462" height="7.17969" rx="2.69238" transform="rotate(-180 26.9238 26.4561)" fill="#141BCB" />
                            </svg>
                        </div>
                    </>
                        : data.type === "notification" ?
                        <>
                            <Handle type="target" position={Position.Left} style={{ top: "24px" }} />
                            <Handle type="source" position={Position.Right} style={{ top: "24px" }} id="conditiona" />
                            <Popover open={showMenu} onOpenChange={() => setShowMenu(!showMenu)} content={menuContent(id)} trigger="contextMenu" title="" placement="bottomLeft">
                                <div className="condition-node cursor-pointer" onClick={handleConnectorClick}>
                                    <MailOutlined />
                                </div>
                            </Popover>

                        </>
                        : data.type === 'httpRequest' ?
                            <>
                                <Handle type="target" position={Position.Left} style={{ top: "24px" }} />
                                <Handle type="source" position={Position.Right} style={{ top: "24px" }} id="conditiona" />
                                <Popover open={showMenu} onOpenChange={() => setShowMenu(!showMenu)} content={menuContent(id)} trigger="contextMenu" title="" placement="bottomLeft">
                                    <div className="condition-node cursor-pointer" onClick={handleConnectorClick}>
                                        {/* Simple globe-like icon using SVG path to avoid new deps */}
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
                                            <path d="M3 12H21M12 3C9 6.5 9 17.5 12 21C15 17.5 15 6.5 12 3Z" stroke="currentColor" strokeWidth="1.5" />
                                        </svg>
                                    </div>
                                </Popover>
                            </>
                            : data.type === 'sharePublicForm' ?
                                <>
                                    <Handle type="target" position={Position.Left} style={{ top: "24px" }} />
                                    <Handle type="source" position={Position.Right} style={{ top: "24px" }} id="conditiona" />
                                    <Popover open={showMenu} onOpenChange={() => setShowMenu(!showMenu)} content={menuContent(id)} trigger="contextMenu" title="" placement="bottomLeft">
                                        <div className="verification-node cursor-pointer" onClick={handleConnectorClick}>
                                            <ShareAltOutlined className="w-4 h-4" />
                                            <span className="veri-label">{t('Share Public Form')}</span>
                                        </div>
                                    </Popover>
                                </>
                                         : data.type === 'outlookCalendar' ?
                                             <>
                                                 <Handle type="target" position={Position.Left} style={{ top: "24px" }} />
                                                 <Handle type="source" position={Position.Right} style={{ top: "24px" }} id="conditiona" />
                                                 <Popover open={showMenu} onOpenChange={() => setShowMenu(!showMenu)} content={menuContent(id)} trigger="contextMenu" title="" placement="bottomLeft">
                                                     <div className="verification-node cursor-pointer" onClick={handleConnectorClick}>
                                                         <SvgIcons type="outlookCalendar" className="w-4 h-4" />
                                                         <span className="veri-label">{t('Outlook Calendar')}</span>
                                                     </div>
                                                 </Popover>
                                             </>
                                         : data.type === 'googlePlaces' ?
                                             <>
                                                 <Handle type="target" position={Position.Left} style={{ top: "24px" }} />
                                                 <Handle type="source" position={Position.Right} style={{ top: "24px" }} id="conditiona" />
                                                 <Popover open={showMenu} onOpenChange={() => setShowMenu(!showMenu)} content={menuContent(id)} trigger="contextMenu" title="" placement="bottomLeft">
                                                     <div className="verification-node cursor-pointer" onClick={handleConnectorClick}>
                                                         <div
                                                             className="step-icon-box icon-box"
                                                             style={{
                                                                 backgroundColor: "#E8E8FA",
                                                                 width: "28px",
                                                                 height: "28px",
                                                                 minWidth: "28px",
                                                                 maxWidth: "28px",
                                                                 borderRadius: "8px",
                                                                 display: "flex",
                                                                 alignItems: "center",
                                                                 justifyContent: "center",
                                                             }}
                                                         >
                                                             <span style={{ color: "#3E44D4", display: "flex" }}>
                                                                 <SvgIcons type="locationFilled" className="w-4 h-4" />
                                                             </span>
                                                         </div>
                                                         <span className="veri-label">{t('Google Places')}</span>
                                                     </div>
                                                 </Popover>
                                             </>
                                            : data.type === "estimation" ?
                                                <>
                                                    <Handle type="target" position={Position.Left} style={{ top: "24px" }} />
                                                    <Handle type="source" position={Position.Right} style={{ top: "24px" }} id="conditiona" />

                                                    <Popover open={showMenu} onOpenChange={() => setShowMenu(!showMenu)} content={menuContent(id)} trigger="contextMenu" title="" placement="bottomLeft">
                                                        <div className="condition-node cursor-pointer" onClick={navigateToEstimation} onContextMenu={handleContextMenu}>
                                                            <MoneyCollectOutlined />
                                                            {/* <span className='delete-node-icon'><DeleteOutlined onClick={confirmNodeDelete}style={{width: "16px", height: "16px"}} /></span> */}
                                                        </div>
                                                    </Popover>

                                                </>
                                                : data.type === 'duplicateCheck' ?
                                            <>
                                                <Handle type="target" position={Position.Left} style={{ top: "24px" }} />
                                                <Handle type="source" position={Position.Right} style={{ top: "24px" }} id="conditiona" />
                                                <Popover open={showMenu} onOpenChange={() => setShowMenu(!showMenu)} content={menuContent(id)} trigger="contextMenu" title="" placement="bottomLeft">
                                                    <div className="verification-node cursor-pointer" onClick={handleConnectorClick}>
                                                        <SvgIcons type="invoiceBilling" className="w-4 h-4" />
                                                        <span className="veri-label">{t('Duplicate Check')}</span>
                                                    </div>
                                                </Popover>
                                            </>

                                                : data.type === "join" ?
                                                    <>
                                                        <Handle type="target" position={Position.Left} style={{ top: "24px" }} />
                                                        <Handle type="target" position={Position.Top} style={{ left: "24px" }} id="targetTop" />
                                                        <Handle type="target" position={Position.Bottom} style={{ left: "24px" }} id="targetBottom" />
                                                        <Handle type="source" position={Position.Right} style={{ top: "24px" }} id="conditiona" />
                                                        <Popover open={showMenu} onOpenChange={() => setShowMenu(!showMenu)} content={menuContent(id)} trigger="contextMenu" title="" placement="bottomLeft">
                                                            <div className="condition-node cursor-pointer" onClick={handleConnectorClick} onContextMenu={handleContextMenu} title={t('Merge / Join')}>
                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M5 4v3a4 4 0 0 0 4 4h6a4 4 0 0 1 4 4v5" stroke="#141BCB" strokeWidth="1.6" strokeLinecap="round" fill="none" />
                                                                    <path d="M5 20v-3a4 4 0 0 1 4-4h6a4 4 0 0 0 4-4V4" stroke="#141BCB" strokeWidth="1.6" strokeLinecap="round" fill="none" />
                                                                    <circle cx="19" cy="12" r="2" fill="#141BCB" />
                                                                </svg>
                                                            </div>
                                                        </Popover>
                                                    </>
                                                : data.type === "end" ?
                                                    <>
                                                        <Handle type="target" position={Position.Left} style={{ top: "24px" }} />
                                                        {/* <Handle type="source" position={Position.Right} style={{ top: "24px" }} id="approve" />
                                    <Handle type="source" position={Position.Bottom} style={{ bottom: 0 }} id="reject" />
                                    <Handle type="target" position={Position.Bottom} style={{ bottom: 0 }} id="targetReject" /> */}

                                                            <div className={`node-card end-node-card ${endExpanded ? "end-node-expanded" : ""}`} onClick={() => setEndExpanded((prev) => !prev)}>
                                                                <Flex className="node-header" align="center" justify="space-between">
                                                                    <Flex align="center" gap={8}>
                                                                        <div className="step-icon-box icon-box" style={{ backgroundColor: "#E8E8FA" }}>
                                                                            <SvgIcons type="workflowEnd" className="w-4 h-4" />
                                                                        </div>
                                                                        <Input
                                                                            className="p-1 truncate"
                                                                            value={endStepName}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                            onChange={(e) => handleStepNameChange(e.target.value)}
                                                                        />
                                                                    </Flex>
                                                                        {endExpanded ? (
                                                                            <Flex align="center" gap={8}>
                                                                                <ChevronDown style={{color: "gray", width: "18px", height: "18px"}} className='cursor-pointer' onClick={(e) => { e.stopPropagation(); setEndExpanded(false); }}/>
                                                                                <DeleteOutlined style={{ color: "#F5222D", fontSize: "14px" }} className='cursor-pointer' onClick={(e) => confirmNodeDelete(e, id)} />
                                                                            </Flex>
                                                                        ) : <ChevronRight style={{color: "gray", width: "24px", height: "24px"}} className='cursor-pointer' onClick={(e) => { e.stopPropagation(); setEndExpanded(true); }} />}
                                                                </Flex>
                                                                {endExpanded ? (
                                                                    <>
                                                                        <Divider className="margin-0" />
                                                                        <div className="end-node-body nodrag nopan" onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
                                                                            <Select
                                                                                size="small"
                                                                                className="nodrag nopan"
                                                                                style={{ width: "100%", marginBottom: 8 }}
                                                                                value={editLang}
                                                                                onChange={setEditLang}
                                                                                options={FORM_LANGUAGE_OPTIONS}
                                                                            />
                                                                            <div className="end-node-title">{t('Notify To')}</div>
                                                                            <UserRoleDropdown
                                                                                selectedOptions={data.notifyTo ? {
                                                                                    "user": data?.notifyTo?.user || [],
                                                                                    "role": data?.notifyTo?.role || [],
                                                                                    "group": data?.notifyTo?.group || [],
                                                                                    "userPicker": data?.notifyTo?.userPicker || []
                                                                                } : { user: [], role: [], group: [], userPicker: [] }}
                                                                                onSelect={handleNotifySelect}
                                                                                tabsRequired={["user", "group", "userPicker"]}
                                                                                getSpaceUsers={true}
                                                                            />
                                                                        </div>
                                                                    </>
                                                                ) : null}
                                                            </div>

                                                    </>
                                                    :
                                                    <>
                                                        <Handle type="target" position={Position.Left} style={{ top: "24px" }} />

                                                        <Popover
                                                            open={isBranchConnector ? showMenu : false}
                                                            onOpenChange={(open) => isBranchConnector && setShowMenu(open)}
                                                            content={menuContent(id)}
                                                            trigger="contextMenu"
                                                            title=""
                                                            placement="bottomLeft"
                                                        >
                                                            <div
                                                                className="nopan"
                                                                onContextMenu={isBranchConnector ? undefined : handleContextMenu}
                                                                style={{
                                                                    position: 'relative',
                                                                    zIndex: 1000,
                                                                    pointerEvents: 'all',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    paddingTop: '6px'
                                                                }}
                                                            >
                                                                <Button
                                                                    size="large"
                                                                    type="primary"
                                                                    icon={<PlusOutlined />}
                                                                    shape="circle"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        e.preventDefault();
                                                                        dispatch(setSidebarOpen(true));
                                                                        dispatch(setSidebarData({ data, id, position, draggable, selectable, type }));
                                                                        dispatch(setSidebarType('addStep'));
                                                                    }}
                                                                    style={{
                                                                        backgroundColor: '#22d3ee',
                                                                        borderColor: '#22d3ee',
                                                                        color: '#ffffff',
                                                                        boxShadow: '0 4px 12px rgba(34, 211, 238, 0.3)',
                                                                        cursor: 'pointer',
                                                                        width: '40px',
                                                                        height: '40px'
                                                                    }}
                                                                    className="workflow-connector-button"
                                                                />
                                                            </div>
                                                        </Popover>
                                                    </>
            }
        </>
    )

}

export default Connector
